import React from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS } from "chart.js/auto";
import { useMemo } from "react";
function PieChart({ chartData }) {
    const chartData_ = useMemo(() => {
        return {
            labels: chartData.options.map((data) => data.option_body),
            datasets: [
                {
                    data: chartData.options.map((data) => data.count  * 100 / (chartData.count)),
                    backgroundColor: [
                        'rgb(255, 99, 132)',
                        'rgb(54, 162, 235)',
                        'rgb(255, 205, 86)',
                        'rgb(104, 162, 135)',
                        'rgb(54, 12, 25)',
                        'rgb(102, 162, 25)',
                        'rgb(4, 12, 23)',
                        'rgb(54, 102, 25)',
                    ],
                    borderColor: "black",
                    borderWidth: 2,
                },
            ],
        }
    }, [chartData]);
    return <Pie data={chartData_} />;
}

export default PieChart;